import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '../../../@core/common.module';
import { CardSnippetModule } from '../../../@core/components/card-snippet/card-snippet.module';
import { ContentHeaderModule } from '../../../app/layout/components/content-header/content-header.module';
import { NouisliderModule } from 'ng2-nouislider';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';

import { AboutusComponent } from '../../../app/main/common/aboutus/aboutus.component';
import { HomeComponent } from '../../../app/main/common/home/home.component';
import { KeyInitiativesComponent } from './key-initiatives/key-initiatives.component';
import { ImportantDocComponent } from './important-doc/important-doc.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ElementsModule } from '../elements/elements.module';
import { InnovationShowcaseComponent } from './innovation-showcase/innovation-showcase.component';
import { ResourcesComponent } from './resources/resources.component';
import { ApplyForFundingComponent } from './apply-for-funding/apply-for-funding.component';
import { InnovativeProjectsComponent } from './innovative-projects/innovative-projects.component';
import { EventComponent } from './event/event.component';

const routes: Routes = [
  {
    path: 'about-us',
    component: AboutusComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'key-initiatives',
    component: KeyInitiativesComponent,
    //canActivate: [AuthGuard],
  },
  {
    path: 'imp-doc',
    component: ImportantDocComponent,
    //canActivate: [AuthGuard],
  },
  {
    path: 'innovation-showcase',
    component:InnovationShowcaseComponent
  },
  {
    path: 'resources',
    component:ResourcesComponent,
  },
  {
    path: 'apply-for-funding',
    component:ApplyForFundingComponent,
  },
  {
    path: 'innovations',
    component:InnovativeProjectsComponent,
  },
  {
    path: 'events',
    component:EventComponent,
  },
];

@NgModule({
  declarations: [
    AboutusComponent, 
    HomeComponent, 
    KeyInitiativesComponent, 
    ImportantDocComponent, 
    ContactUsComponent, InnovationShowcaseComponent, ResourcesComponent, ApplyForFundingComponent, InnovativeProjectsComponent, EventComponent],
  imports: [
    RouterModule.forChild(routes), 
    NgbModule,  
    FormsModule, 
    ReactiveFormsModule, 
    CoreCommonModule,
    NgSelectModule, 
    CardSnippetModule, 
    ElementsModule,
    ContentHeaderModule, 
    NouisliderModule, 
    SwiperModule],
  exports:[AboutusComponent, HomeComponent, KeyInitiativesComponent, ImportantDocComponent, ContactUsComponent],
  providers: [
   
  ]
})
export class CommonModule {}